module.exports = __webpack_public_path__ + "static/media/violin.34fd11cc.mp3";